<template>
  <div :class="classes.skeleton"></div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";

const useStyles = createUseStyles<
  "skeleton" | "@keyframes shimmer",
  { radius: number }
>({
  skeleton: {
    "--radius": props => props.radius - 4 + "px",

    margin: "4px",
    display: "inline-block",
    position: "relative",
    // height: "100%",
    overflow: "hidden",
    backgroundColor: "#dedede88",

    "&::after": {
      position: "absolute",
      zIndex: 12,
      top: 0,
      right: -200,
      bottom: 0,
      left: -200,
      transform: "translateX(-70%)",
      backgroundImage:
        "linear-gradient(90deg, rgba(255,255,255, 0) 0, rgba(255,255,255, 0.06) 20%, rgba(255,255,255, 0.2) 60%, rgba(255,255,255, 0))",
      animation: "$shimmer 2s infinite",
      content: "''"
    }
  },
  "@keyframes shimmer": {
    "100%": {
      transform: "translateX(70%)"
    }
  }
});

export default defineComponent({
  name: "Skeleton",

  setup() {
    const brandContext = injectBrand();

    const reactiveStyles = computed(() => ({
      radius: brandContext?.adTemplate.value?.cardBorderRadius || 0
    }));

    const classes = useStyles(reactiveStyles);

    return { classes };
  }
});
</script>
